

import { Badge, Button, Group, Tooltip, ThemeIcon } from '@mantine/core';
import { HitsPerPage, InstantSearch, Pagination, SearchBox, useHits, InstantSearchProps, Configure, useSortBy, useInstantSearch } from 'react-instantsearch';
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { forwardRef, useContext, useImperativeHandle, useMemo } from 'react';
import { MyUserDataContext } from '../contexts';
import DataTable, { TableColumn } from 'react-data-table-component';

import { useSessionStorage } from '@mantine/hooks';
import { TypesenseTransaction, } from '../types';

import { useNavigate } from 'react-router-dom';
import { IconEye, IconReceipt, IconReceiptRefund } from '@tabler/icons-react';
import { CurrentViewers } from './current_viewers';
import { TagBadge } from './tag_badge';

//typesense

interface InitialState {
    query?: string;
    page?: number;
}
const TRANSACTION_SOURCE_COLORS: Record<string, string> = {
    "kfhtrade": "green",
    "portfolio": "blue",
};
const TRANSACTION_TYPES = [{
    "label": "Cash In",
    "value": "cash_in",
    // type: "cash",
    // action: "Deposit"
},
{
    "label": "Journal Entry",
    "value": "journal_entry",
    // type: "cash",
    // action: "Deposit"
},
{
    "label": "Cash Out",
    "value": "cash_out",
    // type: "cash",
    // action: "Withdraw"
},
{
    "label": "Security In",
    "value": "security_in",
    // type: "security",
    // action: "ReceiveLong"
},
{
    "label": "Security Out",
    "value": "security_out",
    // type: "security",
    // action: "DeliverLong"
},
{
    "label": "FX + Transfer",
    "value": "fx",
    // type: "fx",
    // action: "SpotFX"  //not needed
},

]
export interface RefreshButtonRef {
    refresh: () => void;
}

export const RefreshButton = forwardRef<RefreshButtonRef>((props, ref) => {
    const { refresh } = useInstantSearch();

    useImperativeHandle(ref, () => ({
        refresh
    }));

    return (
        <Button onClick={() => refresh()}>
            Refresh
        </Button>
    );
});

const TableDisplay = ({ setSelectedRows, selectedRows, renderTags, ActionsDetailView, indexName, ...props }: any) => {
    const { items } = useHits();



    const { refine } = useSortBy(
        {
            items: [
                { label: 'Date (asc)', value: `${indexName}/sort/date:asc` },
                { label: 'Date (desc)', value: `${indexName}/sort/date:desc` },
            ]


        }
    );
    const STATUS_COLOR_MAP: Record<string, string> = {
        approve: "green",
        execution: "green",
        done: "green",
        reject: "red",
        review: "yellow",
        approval: "yellow",
        waiting_for_geneva: "yellow",
    };
    const getStatusColor = (status: string): string => { return STATUS_COLOR_MAP[status] || "blue"; }

    const columns: TableColumn<TypesenseTransaction>[] = [
        {
            // name: "Type",
            cell: (row) => {
                let icons = [];
                const transactionType = TRANSACTION_TYPES.find((type) => type.value === row.type);
                const label = transactionType?.label;
                const value = transactionType?.value;
                if (value === "cash_in" || value === "security_in") icons.push(
                    <Tooltip label={label} transitionProps={{ transition: 'scale', duration: 500 }}>
                        <ThemeIcon variant="white" color="green">
                            <IconReceipt size={16} />
                        </ThemeIcon>
                    </Tooltip>
                )
                else if (value === "cash_out" || value === "security_out") icons.push(
                    <Tooltip label={label} transitionProps={{ transition: 'scale', duration: 500 }}>
                        <ThemeIcon variant="white" color="orange">
                            <IconReceiptRefund size={16} />
                        </ThemeIcon>
                    </Tooltip>
                )
                return (<>{icons}</>)
            },
            // sortable: true,
            width: "90px",
        },
        {
            name: <Tooltip label="Current Viewers" transitionProps={{ transition: 'scale', duration: 500 }}><IconEye size={16} /></Tooltip>,
            cell(row,) {

                return (
                    <CurrentViewers type="transactions" id={row.id} />
                );
            },
            width: "90px",
        },
        {
            name: "Name",
            id: "customerObj.name_en",
            selector: (row: TypesenseTransaction) => {

                return row.customerObj?.name_en ?? ""
            },
            sortable: true,
            grow: 1,

        },
        {
            name: "Mobile",
            selector: (row: TypesenseTransaction) => row.customerObj?.mobile ?? "",
            grow: 1,
        },
        {
            name: "Civil ID / Commercial register",
            id: "customerObj.civilID",
            selector: (row: TypesenseTransaction) => (row.customerObj?.civilID || row.customerObj?.commercial_register) ?? "",
            sortable: true,
            grow: 1,

        },
        {
            name: "Type",
            cell: (row) =>
                <Group>
                    <span>
                        {TRANSACTION_TYPES.filter((type) => {
                            return type.value === row.type
                        })[0]?.label}
                    </span>
                    <Badge color={row.source ? TRANSACTION_SOURCE_COLORS[row.source] : undefined} variant="light">
                        {row.source}
                    </Badge>
                </Group>,
            id: "type",
            sortable: false,
        },
        {
            name: "Amount",
            id: "amount",

            cell: (row) => row.is_all_available_cash ? "All" : (row.amount || 0),
            selector: (row) => row.is_all_available_cash ? "All" : (row.amount || 0),
            sortable: false,
        },


        {
            name: "Portfolio",
            id: "portfolioID",
            selector: (row) => row.portfolioID,
            sortable: true,
        },
        {
            name: "Date",
            id: "date",
            sortable: true,

            selector: (row) => row.date,
            cell: (row) => <>
                {row.date ? new Date(row.date * 1000).toLocaleDateString('en-GB') : ""}
            </>

        },



        {
            name: "Tags",
            // wrap: true,
            // width: "150px",
            cell: (row) => {
                if (!row.tags) return null;

                return <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                    <TagBadge m={3} tag={row.tags["transactionStatus"]} key="transactionStatus" />
                    {row.tags["kycStatus"] && <TagBadge m={3} tag={row.tags["kycStatus"]} key="kycStatus" />}
                </div>

            },
        },
        {
            name: "",
            cell: (row: any) => <>

                {ActionsDetailView && <ActionsDetailView typesenseTransactionObg={row} />}
            </>,

            grow: 0,

        }

    ];



    return <DataTable
        columns={columns}
        selectableRows
        sortServer
        onSort={(column, sortDirection) => {
            if (column.id) {
                let sortByValue = `${indexName}/sort/${column.id}`
                if (sortDirection === "asc") {
                    sortByValue += `:asc`
                }
                else {
                    sortByValue += `:desc`
                }

                refine(sortByValue)
            }
        }}
        data={items as any as TypesenseTransaction[]}
    />
}

interface TransactionsInstantSearchProps {
    indexName: string,

    renderTags?: boolean
    ActionsDetailView?: any
    topElements?: JSX.Element
    additionalChildren?: JSX.Element
    defaultFilter?: string
}
const TransactionsInstantSearch = ({ indexName, ActionsDetailView, topElements, additionalChildren, defaultFilter = "" }: TransactionsInstantSearchProps) => {

    // const [transactionsStatusFilter, setTransactionsStatusFilter] = useState<string | null>("")
    const userData = useContext(MyUserDataContext);


    const typesenseSearchClient = useMemo(() => new TypesenseInstantSearchAdapter({
        server: {
            apiKey: userData.customSearchKey!, // Be sure to use a Search API Key
            nodes: [
                {
                    host: import.meta.env.VITE_TYPESENSE_SEARCH_HOST!,
                    port: 443,
                    protocol: 'https'
                },
            ],
        },
        additionalSearchParameters: {

            query_by: "customerObj,customerID,tags,type,portfolioID,custodianAccount"
        }

    }).searchClient, [userData.customSearchKey]);

    if (!indexName) {
        indexName = import.meta.env.VITE_TYPESENSE_ORDERS_COLLECTION!;
    }

    //save to local session
    const [initialUIStateForIndex, setInitialUIStateForIndex] = useSessionStorage<InitialState>({
        key: 'initialUIStateFor' + indexName,
        getInitialValueInEffect: false,
    });


    const onStateChange: InstantSearchProps['onStateChange'] = ({
        uiState,
        setUiState,
    }) => {
        setUiState(uiState);
        setInitialUIStateForIndex(uiState[indexName]);
    };

    // console.log("session for ", indexName, initialUIStateForIndex);

    // if (!initialUIStateForIndex)  {
    //     return <div></div>;
    // }
    return (
        <InstantSearch

            searchClient={typesenseSearchClient}
            indexName={indexName}
            initialUiState={{
                [indexName]: initialUIStateForIndex
            }}
            onStateChange={onStateChange}


        >




            <Configure

                filters={defaultFilter}

            />

            <Group justify="space-between" align='center' style={{ marginBottom: 20 }} >

                {topElements}


                <SearchBox
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",

                        width: "80%",
                        // marginBottom: 20
                    }}
                    autoFocus
                    placeholder='Search...'
                />






                {additionalChildren}

            </Group>

            <TableDisplay
                ActionsDetailView={ActionsDetailView}
                indexName={indexName}
            />

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 12,
                    width: "100%",
                }}
            >

                <HitsPerPage

                    items={[
                        { label: '250', value: 250, },
                        { label: '100', value: 100 },
                        { label: '50', value: 50, default: true },
                    ]}
                />
                <Pagination
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                />
            </div>

        </InstantSearch >



    )
}

export default TransactionsInstantSearch
